import React from "react";
import {
    DesvincularEtapaGrupoDinamicaCotroller,
    DesvincularEtapaGrupoFixaController,
    ListarGrupoDesvinculadosPorEtapaController,
    ListarGrupoVinculadosPorEtapaController,
    VincularEtapaGrupoDinamicaController,
    VincularEtapaGrupoFixaController,
} from "../../../../../../../../../../Controllers/Geral/Etapas/EtapasControllers";
import { ACESSOS } from "../../../../../../../../../../Routes/Acessos";
import VinculadorSimples from "../../../../../../../../../Table/Vinculador";

interface IGruposEtapaProps {
    idEtapa: number;
    idModulo: number;
}

export default function GruposEtapa(props: IGruposEtapaProps) {
    let flEditarCategoriaAtendimento = true;
    return (
        <VinculadorSimples
            listarVinculados={ListarGrupoVinculadosPorEtapaController}
            listarNaoVinculados={ListarGrupoDesvinculadosPorEtapaController}
            acoes={{
                vincular: async (idEtapa, etapaGrupo) => {
                    if (flEditarCategoriaAtendimento) {
                        if (
                            props.idModulo === ACESSOS.ATENDIMENTO.ID_MODULO ||
                            props.idModulo === ACESSOS.REPASSE.ID_MODULO
                        ) {
                            await VincularEtapaGrupoDinamicaController(
                                etapaGrupo.ID_GRUPO,
                                idEtapa
                            );
                        } else {
                            await VincularEtapaGrupoFixaController(
                                etapaGrupo.ID_GRUPO,
                                idEtapa
                            );
                        }

                        return Promise.resolve();
                    } else {
                        await VincularEtapaGrupoDinamicaController(
                            etapaGrupo.ID_GRUPO,
                            idEtapa
                        );
                        return Promise.resolve();
                    }
                },
                desvincular: async (etapaGrupo: any) => {
                    if (flEditarCategoriaAtendimento) {
                        if (
                            props.idModulo === ACESSOS.ATENDIMENTO.ID_MODULO ||
                            props.idModulo === ACESSOS.REPASSE.ID_MODULO
                        ) {
                            await DesvincularEtapaGrupoDinamicaCotroller(
                                etapaGrupo.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO_GRUPO ??
                                    0
                            );
                        } else {
                            await DesvincularEtapaGrupoFixaController(
                                etapaGrupo.ID_ETAPA_TIPO_CASO_GRUPO ?? 0
                            );
                        }

                        return Promise.resolve();
                    } else {
                        await DesvincularEtapaGrupoDinamicaCotroller(
                            etapaGrupo.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO_GRUPO ??
                                0
                        );

                        return Promise.resolve();
                    }
                },
            }}
            flEditarCategoriaAtendimento={flEditarCategoriaAtendimento}
            id={props.idEtapa}
            idModulo={props.idModulo}
            title=""
            tabelaDesvinculados={{
                dataField: "DS_GRUPO",
                key: "ID_GRUPO",
                text: "Grupo Desvinculados",
            }}
            tabelaVinculados={{
                dataField: "DS_GRUPO",
                key: "ID_GRUPO",
                text: "Grupo Vinculados",
            }}
        />
    );
}
